export default "__VITE_ASSET__DRgdbYLt__"